module.exports = file => () => import('src/views/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/views/_import_production.js